import { DataSourceName } from "features/data-source/data-source.types";
import { shouldUseJSBE } from "features/data-source/data-source.utils";
import { useHasUserArea } from "hooks/useHasUserArea";

export const useShouldUseJSBE = (dataSource: DataSourceName) => {
    const hasJSBEDataSourcesEnabled = useHasUserArea(["Refactor_JSBEDataSources"]);
    const useJSBE = shouldUseJSBE(dataSource, hasJSBEDataSourcesEnabled);
    return { useJSBE };
};
